module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABHNCSVQICAgIfAhkiAAAAQRJREFUSIntll2ugyAQRg/N3QKR3VxcWe3Kyt0NDYugD1KgrfUHwZfbLzEmM2SOn44w8NWLXMfVKYZVaxWD6/BOoWuAfbiuq6AjeNWDzoPzgh/gJVDxoZB+CnjOEGMGwSXL6pCfygEgLWYW7BRDVqSuBBdp09uI4KbQROsf7k8x6PltCh0Z0Vhy3OGbgwF5G5mnpYWtVAKe7Nz24Ed3Cnp4/03agYOkxcgbfan73d84uN8Mr9Jc0jKEbjWHgjPpw8FLp9erfnYDFRq/DQo7HYf9fTMUShx7zk6Nd3z5pPG/92pzAC8yErjCxr8owd8bWNo6p84MdHr0yVVlPE0yMD3wfXWI7q1SZIq2BJv/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_live@2x.png
// module id = CMxu
// module chunks = 1